import { cx, styled } from "simplydo/react/styled";

import type { MessageHeaderProps } from "./Message.types";

const HeaderEl = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25em;
  font-family: inherit;
  font-weight: bold;
  margin: 0 0 0.3rem 0;

  > i.icon,
  > svg.icon {
    font-size: 1.5em;
    opacity: 0.8;
  }
`;

const MessageHeaderComponent = (props: MessageHeaderProps) => {
  const { children, className, style } = props;
  return (
    <HeaderEl className={cx(className)} style={style}>
      {children}
    </HeaderEl>
  );
};

export const MessageHeader = styled(MessageHeaderComponent)``;
